export const COLORS = {
    PRIMARY: "#D80027"
};
